import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const COLORES = {
  info:    { bg: '#EFF6FF', border: '#BFDBFE', text: '#1D4ED8', icono: 'ℹ️' },
  warning: { bg: '#FFFBEB', border: '#FDE68A', text: '#B45309', icono: '⚠️' },
  success: { bg: '#ECFDF5', border: '#A7F3D0', text: '#065F46', icono: '✅' },
  error:   { bg: '#FEF2F2', border: '#FECACA', text: '#991B1B', icono: '🚨' },
};

export default function ModalAvisos() {
  const { avisosPendientes, setAvisosPendientes } = useAuth();
  const [indice, setIndice] = useState(0);

  if (!avisosPendientes || avisosPendientes.length === 0) return null;

  const aviso = avisosPendientes[indice];
  const c = COLORES[aviso.color] || COLORES.info;
  const total = avisosPendientes.length;
  const ultimo = indice === total - 1;

  const siguiente = () => {
    if (ultimo) {
      setAvisosPendientes([]);
    } else {
      setIndice(i => i + 1);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(88,28,71,0.55)',
      backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
    }}>
      <div style={{
        background: '#fff',
        border: `2px solid ${c.border}`,
        borderRadius: '20px',
        padding: '36px 32px',
        width: '100%',
        maxWidth: '480px',
        boxShadow: '0 24px 64px rgba(88,28,71,0.2)',
        animation: 'fadeInUp 0.25s ease',
      }}>
        {/* Cabecera */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <span style={{ fontSize: '32px' }}>{c.icono}</span>
          <div style={{ flex: 1 }}>
            <p style={{ color: '#BE84A3', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '3px' }}>
              Aviso importante {total > 1 ? `(${indice + 1} de ${total})` : ''}
            </p>
            <h2 style={{ color: '#581C47', fontSize: '18px', fontWeight: 700, margin: 0 }}>
              {aviso.titulo}
            </h2>
          </div>
        </div>

        {/* Mensaje */}
        <div style={{
          background: c.bg,
          border: `1px solid ${c.border}`,
          borderRadius: '12px',
          padding: '16px 18px',
          marginBottom: '24px',
        }}>
          <p style={{ color: c.text, fontSize: '15px', lineHeight: '1.6', margin: 0, whiteSpace: 'pre-wrap' }}>
            {aviso.mensaje}
          </p>
        </div>

        {/* Botón */}
        <button
          onClick={siguiente}
          style={{
            width: '100%', padding: '13px', borderRadius: '50px',
            background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
            border: 'none', color: '#fff', fontSize: '15px', fontWeight: 600,
            cursor: 'pointer', boxShadow: '0 6px 20px rgba(236,72,153,0.35)',
          }}
        >
          {ultimo ? 'Entendido' : 'Siguiente aviso →'}
        </button>
      </div>
    </div>
  );
}
